import styles from "./DoubleBlock.module.scss";

interface DoubleBlockProps {
  leftTitle: string; // Заголовок лівої частини
  rightText: string; // Текст правої частини
}

const DoubleBlock: React.FC<DoubleBlockProps> = ({ leftTitle, rightText }) => {
  return (
    <div className={styles.doubleBlockContainer}>
      <div className="container sideP88">
        <div className={styles.doubleBlock}>
          <div className={styles.leftSide}>
            <h1 className={styles.leftTitle}>{leftTitle}</h1>
          </div>
          <div className={styles.rightSide}>
            <p>{rightText}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoubleBlock;
